import request from '@/axios';

// 获取黑名单列表
export const getBlackList = (data) => {
  return request({
    url: '/lebo-ad/blackList/page',
    method: 'get',
    params: data
  })
}

// 获取黑名单详情
export const getBlackListDetail = (id) => {
  return request({
    url: '/lebo-ad/blackList/detail/' + id,
    method: 'get'
  })
}

// 新增黑名单
export const addBlackList = (data) => {
  return request({
    url: '/lebo-ad/blackList/add',
    method: 'post',
    data: data
  })
}

// 更新黑名单
export const updateBlackList = (data) => {
  return request({
    url: '/lebo-ad/blackList/update',
    method: 'post',
    data: data
  })
}

// 删除黑名单
export const deleteBlackList = (id) => {
  return request({
    url: '/lebo-ad/blackList/delete/' + id,
    method: 'post'
  })
}

// 批量删除黑名单
export const batchDeleteBlackList = (ids) => {
  return request({
    url: '/lebo-ad/blackList/batchDelete',
    method: 'post',
    data: { ids: ids }
  })
}